import { ITimestampResponse } from '@/types/common';

/** サーバーの ScreenMediaPlacement と一致させること */
export enum ScreenMediaPlacement {
  WAITING_CREATE_POST = 'waitingCreatePost',
}

export const SCREEN_MEDIA_PLACEMENT_LABELS: Record<
  ScreenMediaPlacement,
  string
> = {
  [ScreenMediaPlacement.WAITING_CREATE_POST]: '日記の作成中画面',
};

/** サーバーの ScreenMediaType と一致させること（0 は使わない） */
export enum ScreenMediaType {
  IMAGE = 1,
  VIDEO = 2,
}

export const SCREEN_MEDIA_TYPE_LABELS: Record<ScreenMediaType, string> = {
  [ScreenMediaType.IMAGE]: '静止画',
  [ScreenMediaType.VIDEO]: '動画',
};

/** サーバーの ScreenMediaStatus と一致させること */
export enum ScreenMediaStatus {
  DRAFT = 0,
  PUBLIC = 1,
  HIDDEN = 2,
}

export const SCREEN_MEDIA_STATUS_LABELS: Record<ScreenMediaStatus, string> = {
  [ScreenMediaStatus.DRAFT]: '下書き',
  [ScreenMediaStatus.PUBLIC]: '公開',
  [ScreenMediaStatus.HIDDEN]: '非表示',
};

export interface IScreenMedia extends ITimestampResponse {
  id: number;
  placement: ScreenMediaPlacement;
  title: string;
  mediaType: ScreenMediaType;
  provider: string;
  mediaUrl: string | null;
  posterUrl: string | null;
  /** numeric 列なのでサーバーは文字列で返す */
  durationSec: string | null;
  width: number | null;
  height: number | null;
  /** bigint 列なのでサーバーは文字列で返す */
  fileSizeBytes: string | null;
  videoCodec: string | null;
  sortOrder: number;
  publicAt: string | null;
  publicEndAt: string | null;
  status: ScreenMediaStatus;
}

export interface IGetListScreenMediaResponse {
  data: IScreenMedia[];
  pagination: {
    currentPage: number;
    pageSize: number;
    total: number;
  };
}

export interface IRotationPreviewRow {
  date: string;
  screenMediaId: number | null;
  title: string | null;
  mediaType: 'image' | 'video' | null;
}

/** POST /uploads/video のレスポンス */
export interface IUploadVideoResponse {
  url: string;
  durationSec: number | null;
  width: number | null;
  height: number | null;
  videoCodec: string | null;
  fileSizeBytes: number;
}
